<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2>
          <a href="/users/sign_up">
            まぐわったに登録して
          </a>
        </h2>
        <span v-html="notation"></span>
        <button type="button" @click="notation = pickNotation()" class="btn btn-sm btn-outline-secondary">
          <i class="fas fa-sync-alt"></i>
        </button>
        <p class="mt-2" v-if="showTimelineButton">
          <a href="/mags" class="btn btn-outline-primary btn-sm">
            <i class="fas fa-stream">
              まぐわいを見る
            </i>
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['showTimelineButton'],
  data() { return { notation: this.pickNotation() } },
  mounted() {
  },
  methods: {
    pickNotation() {
      const texts = [
        "今すぐあなたのセックスをシェアしよう！",
        "セックスを記録し、振り返り、改善しよう。",
        "自分たちのセックスに投資しよう",
        "イデオロギーの時代ではなくテクノロジーの時代に生きよう",
        "人間社会におけるあらゆる行動を、通信と制御によって捉えよう",
        "人間を機械の一種として捉え直そう",
        "自然と文明を計算機で接続しよう",
        "インターネットの登場で社会が直面する問題を考えよう",
        "全ての毛穴がはっきりと開いたあの瞬間を記録しよう",
        "記録も消費も、同じ一つの「進行中の生産」とみなそう",
        "セックスに関心を持ち、セックスの記録をつけることはもうかっこ悪いことじゃなくしよう。<br />セックスは生活のもとになるもの。自分の生活に関心がない人なんていないでしょ？<br />セックスを記録するのは普通のこと。<br />もうなすがままにセックスして内容を忘れるのやめましょう",
        "自分にも他人にも優しくしよう",
        "リレーコンピュータで繋いでいた旧第一勧銀と旧富士銀の勘定系システムを一本化しよう",
        "FintechやAIやブロックチェーンなど新技術の活用、少子高齢化時代を見据えたビジネス変革など、直面する様々な課題に生活面から備えよう",
        "性交のフェーズ管理をうまく運用しよう。<br />フェーズ移行判定基準明確にし、自分や相手の体質にマッチした移行判定基準を用いよう。そうでないと性交フェーズに対する認識がバラバラになってしまい、せっかく性交フェーズ管理を導入していても精度はいつまで立っても向上しない。<br />自身の体質や性交の進め方を研究して、自分に合ったフェーズ設計に挑戦しよう。",
      ]
      return texts[Math.floor(Math.random() * texts.length)]
    }
  }
}
</script>

<style scoped>
</style>
